
import API from '../utils/request'
export function saveApplication (data) {
  return API.postWith('/management/applyhub/save', data)
}
export function getIndustryList (data) {
  return API.get('/management/applyhub/getIndustryList', data)
}
export function getVasType (data) {
  return API.get('/management/applyhub/getVasType', data)
}
export function changeApplyhub (data) {
  return API.post('/management/applyhub/change', data)
}
export function getTemplateDto (data) {
  return API.get('/management/applyhub/getList', data)
}
export function getProductList (data) {
  return API.get('/management/applyhub/getProductList', data)
}
export function getProductTypeList (data) {
  return API.get('/management/applyhub/getProductTypeList', data)
}
export function getInfoDetails (data) {
  return API.get('/management/applyhub/getInfo', data)
}
export function updateAlias (data) {
  return API.post('/management/applyhub/updateAlias', data)
}
// 角标
export function getVasLabel (data) {
  return API.get('/management/applyhub/getVasLabel', data)
}
// 角标
export function getCustomerChannelList (data) {
  return API.get('/management/applyhub/getCustomerChannelList', data)
}
